import { render, staticRenderFns } from "./GroupPermissions.vue?vue&type=template&id=adc56830&scoped=true"
import script from "./GroupPermissions.vue?vue&type=script&lang=js"
export * from "./GroupPermissions.vue?vue&type=script&lang=js"
import style0 from "./GroupPermissions.vue?vue&type=style&index=0&id=adc56830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc56830",
  null
  
)

export default component.exports